import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function ResetPasswordPage() {
  const [searchParams]          = useSearchParams()
  const navigate                = useNavigate()
  const { login }               = useAuth()

  const token                   = searchParams.get('token') ?? ''
  const [password,  setPassword] = useState('')
  const [confirm,   setConfirm]  = useState('')
  const [showPass,  setShowPass] = useState(false)
  const [error,     setError]    = useState('')
  const [loading,   setLoading]  = useState(false)

  // If no token in URL, redirect to login
  useEffect(() => {
    if (!token) navigate('/login')
  }, [token, navigate])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }

    setLoading(true)
    try {
      const res  = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error)

      // Log the user in and take them to the dashboard
      login(data.token, data.user)
      navigate('/dashboard')
    } catch (err: any) {
      setError(err.message ?? 'Password reset failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="app" style={{ minHeight: '100vh' }}>
      <header className="app-header">
        <div className="header-logo">🏎️</div>
        <div className="header-title">
          <h1>Race Day Pool</h1>
          <p>Indianapolis Motor Speedway · May 24, 2026</p>
        </div>
        <nav className="header-nav">
          <button className="nav-btn" onClick={() => navigate('/')}>← Home</button>
        </nav>
      </header>

      <main className="app-main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ maxWidth: 400, width: '100%', padding: '0 1rem' }}>

          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <div style={{ fontSize: '2.5rem' }}>🔑</div>
            <h2 style={{ color: '#fff', margin: '0.5rem 0 0.25rem' }}>Set New Password</h2>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.85rem', margin: 0 }}>
              Choose a strong password for your account
            </p>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>

            {/* New password */}
            <div style={{ position: 'relative' }}>
              <input
                className="form-input"
                type={showPass ? 'text' : 'password'}
                placeholder="New password (min 8 characters)"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{ paddingRight: '2.8rem' }}
              />
              <button
                type="button"
                onClick={() => setShowPass(p => !p)}
                style={{
                  position: 'absolute', right: '0.75rem', top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer',
                  color: 'rgba(255,255,255,0.5)', fontSize: '1rem', padding: 0,
                  lineHeight: 1,
                }}
                title={showPass ? 'Hide password' : 'Show password'}
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>

            {/* Confirm password */}
            <input
              className="form-input"
              type={showPass ? 'text' : 'password'}
              placeholder="Confirm new password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />

            {error && (
              <div style={{ color: '#ff6b6b', fontSize: '0.82rem', padding: '0.5rem 0.75rem', background: 'rgba(255,107,107,0.1)', borderRadius: 6 }}>
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: '0.25rem' }}>
              {loading ? '…' : '🔑 Set New Password'}
            </button>

            <div style={{ textAlign: 'center', marginTop: '0.25rem' }}>
              <button
                type="button"
                onClick={() => navigate('/login')}
                style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', fontSize: '0.78rem', cursor: 'pointer', textDecoration: 'underline' }}
              >
                ← Back to Sign In
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  )
}
